(function ($) {
  customerServiceMenuMobileV1 = {
    formatter: $('.cs-menu-mobile-v1')
  };

  Drupal.behaviors.customerServiceMenuMobileV1 = {
    get: function (key) {
      return customerServiceMenuMobileV1[key];
    },

    set: function (key, val) {
      customerServiceMenuMobileV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function (i) {
        var thisFormatter = $(this);

        // Mobile CS navigation menu
        thisFormatter.find('h2.cs-slide-menu-heading > a').each(function (i) {
        // Get accordion items
          var accordionItemsWrapper = $(this).parent().parent().nextUntil('li.slide').children();

          $(this).on('click', function(e) {
          // Check if there is any available link URL and if not (href equals 1) prevent default behavior
            if ($(this).attr('href').length === 1) {
              e.preventDefault();
            }

            // First value for left offset, second value for top offset
            window.scrollTo(-100, 0);

            // Hide Customer Care (top section)
            $('.cs-formatter-rows').hide();

            // Show accordion items under this
            var accordionItems = $(this).parent().parent().nextUntil('li.slide').children();

            accordionItems.show();

            // Hide main CS menu
            $('.cs-menu').animate({
              left: '-100%',
              scrollTop: $('body').offset().top
            }, { duration: 500 });

            // Reset left margin and find and show accordion items
            accordionItemsWrapper.css({ 'margin-left': '0' });
            accordionItemsWrapper.find('h3 span.heading-text').show();

            // Hide all CS main menu
            $('h2.cs-slide-menu-heading').hide();

            // Show back button
            $(this).parent().parent().next().first().children().find('h2.back').show();

            // Populate the back link with its parent menu item text
            $(this).parent().parent().next().first().children().find('h2.back span:last').first().text($(this).text());
          });
        });

        // Back to the CS main menu
        thisFormatter.find('.depth-1 > h2.back > a').each(function (i) {
          $(this).on('click', function(e) {
            e.preventDefault();
            window.scrollTo(-100, 0); // first value for left offset, second value for top offset

            // Show main CS menu
            $('.cs-menu').animate({
              left: '0',
              scrollTop: $('body').offset().top
            }, { duration: 10 });

            // Show Customer Care and slide menu items
            $('.cs-formatter-rows, h2.cs-slide-menu-heading').show();

            // Hide accordion menu wrapper
            $('.menu-container.depth-1').hide();
          });
        });

        // Basic Accordion Functionality
        // h3 headings will be used as the accordion triggers
        thisFormatter.find('h3').on('click', function() {
        // Find the accordion contnet div and add a bottom border when content is visible
          $(this).next().find('.cs-accordion-content').css({ 'border-bottom': '1px solid #CCC' });

          // Auto adjust page scroll height. Needs more fine tune 
          // $('body').scrollTo($(this), {duration:'slow', offsetTop : '75'});

          // Add or remove the "selected" class on the clicked h3 accordion item
          $(this).toggleClass('selected');

          // Remove the "selected" class from all inactive h3 accordion items
          $(this).parent().parent().siblings().find('h3').removeClass('selected');

          // Find inactive h3 accordion item content and hide it
          $(this).parent().parent().siblings().find('h3').next().hide('fast');

          // Slide and show the accordion content
          $(this).next().slideToggle('slow');
        });
      });
    }
  };
})(jQuery);
